import { atom } from 'jotai';

export const observationViewState = atom('map');
